import * as MobX from "mobx";
import { Stores } from "../Stores";
import { BaseStore, KeyValuePair } from "@shoothill/core";
import { InitialState } from "Globals/Models";
import { RejectReason } from "Globals/Models/RejectReason";

export class RejectReasonStore extends BaseStore {
    public constructor() {
        super();
    }
    @MobX.observable private rejectReason: RejectReason[] = [];
    public async init(stores: Stores, initialState: InitialState) {
        this.rejectReason = initialState.rejectReasons;
    }

    @MobX.action
    public getRejectReasonName(rejectReasonId: string | null): string {
        if (rejectReasonId == "0" || rejectReasonId == null || rejectReasonId == "") return "Error";
        let value = this.getSortedByOrdinal.find((value) => rejectReasonId === value.id);
        return value ? value.name : "Unknown";
    }

    @MobX.computed
    public get getSortedByOrdinal(): RejectReason[] {
        return this.rejectReason.slice().sort((a, b) => (a.ordinal < b.ordinal ? -1 : 1));
    }

    @MobX.computed
    public get getRejectReasonOptions(): KeyValuePair[] {
        return this.getSortedByOrdinal.map((value) => ({ value: value.id, key: value.name })) as KeyValuePair[];
    }
    public getRejectReasons = (): RejectReason[] => {
        return this.rejectReason;
    };
}
